import { isChecked, useTranslation } from '@gimlite/common';
import {
  Checkbox,
  Col,
  Form,
  Row,
  Space,
  WizardItemType,
  Write,
} from '@gimlite/ui-v1';
import React, { useMemo } from 'react';
import { CreateFPSWizardContext } from '../../createFps.wizard';
import './confirm.step.scss';

export const ConfirmStep = ({
  context,
  validate,
  submit,
}: WizardItemType.Config.Component<CreateFPSWizardContext>) => {
  const { t, lang }: any = useTranslation();

  const cases = useMemo(() => {
    if (!context?.confirm) return [];

    const result: { title: React.ReactNode; description: React.ReactNode }[] =
      [];

    if (context?.confirm?.right) {
      result.push({
        title: (
          <Write
            data={{ item: t('rightInThePeriod') }}
            config={{
              mode: 'title-small',
            }}
          ></Write>
        ),

        description: (
          <Write
            data={{ item: t('RIGHT_IN_PERIOD_ADVERTISSEMENT') }}
            config={{ mode: 'value-small' }}
          />
        ),
      });
    }

    // if (context?.confirm?.claim) {
    //   result.push({
    //     title: (
    //       <Write
    //         data={{ item: t('rapo') }}
    //         config={{
    //           mode: 'title-small',
    //         }}
    //       ></Write>
    //     ),
    //     description: (
    //       <>
    //         <div className="confirmForReason">
    //           <Write
    //             data={{ item: t('RAPO_ADVERTISSEMENT') }}
    //             config={{ mode: 'value-small' }}
    //           />
    //           {context?.claimReasons && context?.claimReasons?.length > 0 && (
    //             <div className="confirmForReasonContent">
    //               <Write
    //                 data={{ item: 'Reasons :' }}
    //                 config={{ mode: 'value-small' }}
    //               />
    //               <ul className="confirmForReasonContentList">
    //                 {context?.claimReasons.map((value: string) => (
    //                   <li>
    //                     <Write
    //                       data={{ item: t(`CLAIM_REASON_${value}`) }}
    //                       config={{ mode: 'value-small' }}
    //                     />
    //                   </li>
    //                 ))}
    //               </ul>
    //             </div>
    //           )}
    //         </div>
    //       </>
    //     ),
    //   });
    // }

    return result;
  }, [context?.confirm, lang]);

  return (
    <Form
      className="confirmForm"
      data={{ value: context }}
      config={{ validateOnChange: true }}
      handleEvent={{
        change: (value: any) => {
          submit(value);
        },
        validate: (value: any) => {
          validate(value);
        },
      }}
    >
      <Write
        data={{ item: t('aboutFineVehicle') }}
        config={{
          mode: 'title-small',
        }}
      ></Write>
      <Space config={{ count: 2 }}></Space>
      {cases.map(({ title, description }, index) => {
        return (
          <label
            key={`confirm-wizard-create-fps-choice-${index}`}
            id={`confirm${index}`}
            className={`confirmCase ${
              context?.[`confirm${index as 0 | 1}`] ? 'confirmCaseSelected' : ''
            }`}
          >
            <Col>
              <Row>{title}</Row>
              <Space config={{ count: 2 }}></Space>
              <Row>
                <Form.Item
                  data={{ defaultValue: '' }}
                  config={{
                    way: 'horizontal',
                    name: `confirm${index}`,
                    rules: [
                      {
                        required: true,
                      },
                      {
                        validator: isChecked,
                      },
                    ],
                  }}
                >
                  <Checkbox />
                </Form.Item>
                <Space config={{ count: 2, way: 'horizontal' }}></Space>

                {description}
                <Write
                  className="confirmWrite"
                  // data={{ item: description }}
                  data={{ item: '' }} //! A CORRIGER
                ></Write>
              </Row>
            </Col>
          </label>
        );
      })}
    </Form>
  );
};
